import { ChangeDetectionStrategy, Component, computed, effect, inject, input, model, signal, Signal } from '@angular/core';
import { Button } from 'primeng/button';
import { Drawer } from 'primeng/drawer';
import { FormGroup, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { WalletFormComponent } from "../../forms/wallet-form/wallet-form";
import { FormFactoryService } from '../../services/utility/form-factory.service';
import { WalletStoreService } from '../../services/etiquette-service/wallet-store.service';
import { AbstractToggleSidePanelComponent } from '../abstract-toggle-side-panel/abstract-toggle-side-panel';
import { Trade } from '../../models/trade.model';
import { AsyncApiService } from '@spike/core';
import { EntityApiEnum } from 'src/app/config/entity-api.enum';
import { TradeFormComponent } from "../../forms/trade-form/trade-form";
import { ConfirmationDialogService } from '../../services/utility/confirmation-dialog.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-trade-side-panel',
  providers:[],
  imports: [CommonModule, FormsModule, Button, Drawer, TradeFormComponent],
  templateUrl: './trade-side-panel.html'
})
export class TradeSidePanelComponent extends AbstractToggleSidePanelComponent<Trade>{
  private readonly formFactory = inject(FormFactoryService);
  private readonly asyncApi = inject(AsyncApiService);
  private readonly tradeApiEnum = EntityApiEnum.FIN_TRADE;
  private readonly confirmationService = inject(ConfirmationDialogService);


  public readonly finTradeTypeId = input.required<number>();
  override disabledFields: Signal<string[]> = signal([]);

  protected override buildFormArrays(data: Trade): void {
    
  }

  drawerTitle = computed(()=>{
    const finTradeTypeId = this.finTradeTypeId();
    if (finTradeTypeId==1){return 'Entrata'}
    else if (finTradeTypeId==2){return 'Uscita'}
    else if (finTradeTypeId==3){return 'Giroconto'}
    else if (finTradeTypeId==4){return 'Investimento'}
    else return 'Operazione'    
  });
  
  public readonly form: FormGroup<any> =this.formFactory.createTradeForm();
  public readonly data = model<Trade>();

  async onSaveClicked() {
    this.form.markAllAsTouched();

    if (this.form.valid) {
      const generalValues = this.form.getRawValue() as Trade;
      const finTradeTypeId = this.finTradeTypeId();
      const isModifica = !!generalValues.finTradeId;

      let toSaveData: Trade = {
        ...generalValues,
        finTradeTypeId: finTradeTypeId
      };

      if (!isModifica) {
        toSaveData.amount = finTradeTypeId === 1 
          ? Math.abs(generalValues.amount) 
          : -Math.abs(generalValues.amount);
      } else {
        toSaveData.finTradeTypeId = generalValues.amount >= 0 ? 1 : 2;
      }

      const tradeToSave: Trade = await this.asyncApi.save(
        this.tradeApiEnum, 
        toSaveData, 
        toSaveData.finTradeId
      );

      this.onSave.emit(tradeToSave);
      this.data.set(tradeToSave);
      // this.formView.set(false)
    }
  }

  public async onDeleteClicked() {
    const data = this.data();
    await new Promise<void>((resolve) => {
      this.confirmationService.show('Sei sicuro di voler eliminare questa posizione?', async () => {
          await this.asyncApi.deleteById(this.tradeApiEnum, data?.finTradeId!);
          this.onDelete.emit();
          resolve();
      });
    });
  }

}